import { PLAYER_ROUTE_NAMES, PLAYER_PREVIEW_KIND } from "@/apps/player/player.routes";
import { goToField } from "@/shared/utils";

export function usePlayerGoTo() {
    return {
        goToLinkField(linkId, fieldId) {
            goToField(
                PLAYER_ROUTE_NAMES.projectLayout,
                PLAYER_PREVIEW_KIND.player,
                fieldId,
                "edit",
                linkId
            );
        },
        goToLayoutField(fieldId) {
            goToField(PLAYER_ROUTE_NAMES.projectLayout, PLAYER_PREVIEW_KIND.player, fieldId);
        },
        goToFileField(fileId, fieldId) {
            goToField(
                PLAYER_ROUTE_NAMES.projectFiles,
                PLAYER_PREVIEW_KIND.player,
                fieldId,
                "edit",
                fileId
            );
        },
    };
}
